import styled from 'styled-components'

export const StyledInputSelectProjectWrapper = styled.div`
    width: fit-content;
    min-width: 250px;
`
